import type { FaireProductEntity } from "../../entity_types/product";

export const p_phbbv2bpxs: FaireProductEntity = {
  token: "p_phbbv2bpxs",
  type: "product",
  name: "Friend Of The Year Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e0aad9628de7968263b0035503bee72ccd37f392b2d5e02e6ee32ade2e7d1007.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4b5fc2cd29f996e248bd4b7b1e91963b8f1759d95fb0cd0674289e90a296726.jpeg",
    "https://cdn.faire.com/fastly/9a298b257bbc4c69b8bed94a4aed30841ac562a9da09ff6e61df288ccd2af786.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/52b014187be5f335a843ce3bc92ce8896b907e58205b9e9efab369a5b656afb5.jpeg",
    "https://cdn.faire.com/fastly/ff2d963cb7b4e58721855f176044dc84b89ca23ad0c03bfb1ffa5a5352971329.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the ones who show up, bring snacks, and do a really good job pretending to listen—they deserve these socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:07.778Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
